import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  setEncryptedItem,
  getDecryptedItem,
  removeItem,
} from "../src/utils/storageUtils";
import AppRoute from "./route/AppRoute";
import { check_login_status } from "./pages/login/Login.Slice";

import LayoutNoauth from "./layouts/LayoutNoauth";
import LayoutAuth from "./layouts/LayoutAuth";
import { logout } from "./pages/login/Login.Slice";

function App() {
  const dispatch = useDispatch();
  const loggedin = useSelector((state) => state.LoginSlice.loggedin);
  const userType = getDecryptedItem("usertype");

  useEffect(() => {
    dispatch(check_login_status());
    if (userType === null) {
      dispatch(logout());
    }
  }, [dispatch]);

  return (
    <>
      <Router>
        {loggedin ? (
          <div>
            <LayoutAuth />
            <br />
          </div>
        ) : (
          <div>{/* <LayoutNoauth /> */}</div>
        )}
        <div className="page_container">
          <AppRoute loggedin={loggedin} />
        </div>
      </Router>
    </>
  );
}

export default App;
